<template>
  <div class="modal fade" :class="{ show: props.isModalOpen, 'd-block': props.isModalOpen }" :id="id" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" :aria-labelledby="props.id + 'Label'" aria-hidden="true">
    <div class="modal-dialog" :class="(props.modalSize) && `modal-${props.modalSize}`">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" :id="props.id + 'Label'">{{props.title}}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Закрыть" @click="$emit('isModalOpen', false)"></button>
        </div>
        <div class="modal-body">
          <slot/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps} from 'vue'
const props = defineProps({
  id: String,
  title: String,
  isModalOpen: Boolean,
  modalSize: String
})
</script>
